export default __webpack_public_path__ + "static/media/video4.e1e61b71.webp";